import React from "react";
import "./LoadingIcon.css";

const LoadingIcon = (args) => {
    return (
        <div className={args.mono === "true" ? "logo-box mono" : "logo-box"}>
            <div className="logo-arrow"></div>
            <div className="logo-ring"></div>
        </div>
    )
};

export default LoadingIcon; 


// WEBPACK FOOTER //
// ./src/components/common/LoadingIcon.js